import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { APP_FILE_APP_FORM_LIST } from "./AppForm.constants";

const AppFormList = Loadable(
  lazy(() =>
    import("./AppFormList").then(({ AppFormList }) => ({
      default: AppFormList,
    }))
  )
);

export const appFormRoutes = [
  {
    path: `${APP_FILE_APP_FORM_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <AppFormList />
      </AuthorizedRoute>
    ),
  },
];
